import 'react-hot-loader/patch';
import 'reflect-metadata';
import '@shared/i18n';

import 'reset-css';

import DateFnsUtils from '@date-io/moment';
import { ThemeProvider } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { QueryClientProvider } from '@tanstack/react-query';
import { render } from 'react-dom';
import { Provider as ReduxProvider } from 'react-redux';
import { Router } from 'react-router-dom';

import { CombinedOptionsProvider } from '@landlord/contexts/OptionsContext';
import { routeTitles } from '@landlord/routes/routes.constant';
import { createTheme } from '@landlord/theme/utils/create-theme';
import store from '@redux/store';
import { AgreementModalOutlet } from '@shared/components/agreement-modal';
import { ConfigProvider } from '@shared/contexts/ConfigContext';
import { AppId } from '@shared/contexts/ConfigContext';
import { PusherProvider } from '@shared/contexts/PusherContext';
import { RouteProvider } from '@shared/contexts/RouteContext';
import { UnsavedChangesProvider } from '@shared/contexts/UnsavedChangesContext';
import { history } from '@shared/utils/history';
import { queryClient } from '@shared/utils/http-client';

import { App } from './App';

import '@shared/assets/scss/iconFonts.scss';
import '@shared/assets/scss/mapOverride.scss';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file

const theme = createTheme();

render(
  <Router history={history}>
    <RouteProvider routeTitles={routeTitles}>
      <ThemeProvider theme={theme}>
        <ReduxProvider store={store}>
          <QueryClientProvider client={queryClient}>
            <AgreementModalOutlet />
            <ConfigProvider appId={AppId.Landlord}>
              <PusherProvider>
                <UnsavedChangesProvider>
                  <CombinedOptionsProvider>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <App />
                    </MuiPickersUtilsProvider>
                  </CombinedOptionsProvider>
                </UnsavedChangesProvider>
              </PusherProvider>
            </ConfigProvider>
          </QueryClientProvider>
        </ReduxProvider>
      </ThemeProvider>
    </RouteProvider>
  </Router>,
  document.getElementById('root')
);
